export function initCheckout() {
	// ── Checkout: prepend a lead-in title to the checkout notice group ──
	// Text varies by the type of notice WooCommerce dropped in (error / info / message),
	// so different responses (validation, gateway, info) get a relevant heading.
	(function initCheckoutNoticeTitle() {
		const $ = window.jQuery;
		if (!$) {
			return;
		}

		const titles = {
			error: 'There was an issue with submitting your order, please check the following:',
			info: 'Please note:',
			message: 'Order update:'
		};

		const addTitle = function () {
			document.querySelectorAll('.woocommerce-NoticeGroup-checkout').forEach(function (group) {
				if (group.querySelector('.msf-notice-title')) {
					return;
				}
				let type = 'message';
				if (group.querySelector('.woocommerce-error')) {
					type = 'error';
				} else if (group.querySelector('.woocommerce-info')) {
					type = 'info';
				}
				const title = document.createElement('p');
				title.className = 'msf-notice-title msf-notice-title--' + type;
				title.textContent = titles[type];
				group.insertBefore(title, group.firstChild);
			});
		};

		$(document.body).on('checkout_error', addTitle);
	})();

	// ── Checkout: reveal the coupon field behind the "Apply coupon" link ──
	(function initCouponToggle() {
		document.addEventListener('click', function (e) {
			const toggle = e.target.closest('.js-msf-coupon-toggle');
			if (!toggle) {
				return;
			}
			e.preventDefault();
			const panel = toggle.parentNode.querySelector('.js-msf-coupon-panel');
			if (!panel) {
				return;
			}
			const show = panel.hasAttribute('hidden');
			if (show) {
				panel.removeAttribute('hidden');
			} else {
				panel.setAttribute('hidden', '');
			}
			toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
		});
	})();

	// ── Checkout: apply coupon from inside the order summary ──
	// The coupon field can't be a nested <form> (it lives inside the checkout form),
	// so apply via WC's AJAX endpoint directly. Removal reuses WC's native handler.
	(function initCheckoutCoupon() {
		const $ = window.jQuery;
		if (!$ || typeof wc_checkout_params === 'undefined') {
			return;
		}

		$(document).on('click', '.js-msf-apply-coupon', function () {
			const wrap = this.closest('.msf-coupon');
			const input = wrap && wrap.querySelector('input[name="coupon_code"]');
			const code = input ? input.value.trim() : '';
			if (!code) {
				return;
			}

			$.ajax({
				type: 'POST',
				url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
				data: { security: wc_checkout_params.apply_coupon_nonce, coupon_code: code },
				dataType: 'html',
				success: function (response) {
					// Notices go above the form so the order-summary re-render doesn't wipe them.
					$('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();
					if (response) {
						$('form.checkout').before(response);
					}
					$(document.body).trigger('update_checkout', { update_shipping_method: false });
				}
			});
		});
	})();
}
